import type { ColumnState } from "@ag-grid-enterprise/all-modules";
import { z } from "zod";

export enum ColumnPinMode {
  NO_PIN = "no pin",
  LEFT = "left",
  RIGHT = "right",
}

export enum TableSettingsTableName {
  EMPLOYEE = "Employee",
  PAY_RANGE = "Pay Range",
}

export enum ColumnVisibility {
  SHOW = "SHOW",
  INITIAL_HIDE = "INITIAL_HIDE",
  ALWAYS_HIDE = "ALWAYS_HIDE",
  ADMIN_ONLY_INITIAL_HIDE = "ADMIN_ONLY_INITIAL_HIDE",
  ADMIN_ONLY = "ADMIN_ONLY",
  FORBID = "FORBID",
}

export const ColumnPlacementConfigSchema = z.object({
  colId: z.string(),
  visibility: z.nativeEnum(ColumnVisibility),
  pinned: z.nativeEnum(ColumnPinMode).optional(),
});

export type ColPlacementConfig = z.infer<typeof ColumnPlacementConfigSchema>;

export type ColumnConfig = Pick<ColumnState, "colId" | "hide" | "sort" | "pinned"> & {
  visibility?: ColumnVisibility;
};
